import { Element } from "@app/types/Cue";
import { Type } from "@app/types/enums";
import cx from "classnames";

import Paragraph from "./Paragraph";

type ListNumberedProps = {
  className?: string;
  elements: Element[];
};

export default function ListNumbered({
  className,
  elements,
}: ListNumberedProps): React.ReactElement {
  return (
    <ol
      className={cx("list-outside list-decimal pl-8", className)}
      data-story-element={Type.ListNumbered}
      data-testid="list-numbered-component"
    >
      {elements.map((element) => {
        switch (element.type) {
          case Type.Paragraph:
            return (
              <li key={element.id}>
                <Paragraph element={element} />
              </li>
            );

          default:
            return null;
        }
      })}
    </ol>
  );
}
